import { Theme, css } from '@emotion/react'

export const title = (theme: Theme) => css`
  font-weight: 700;
  color: ${theme.typographyColors.typographyTwo};
`

export const subtitle = (theme: Theme) => css`
  width: 339px;
  font-weight: 300;
  text-align: center;
  line-height: 28px;
  color: ${theme.typographyColors.typographyThree};
  margin-top: -7px;
`
